module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/5da75ecc9244c28c3c80a3746d0762d6.svg";